<template>
  <v-container>
    <h1>Check OpenAi</h1>

    <progress-component script="CheckOpenAi"></progress-component>
  </v-container>
</template>

<script>

import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'CheckOpenAi',
  components: { ProgressComponent },
};
</script>
